import { useEffect, useState } from "react";

const getWidth = () =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;
const getHeight = () =>
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight;

interface WindowSize {
  width: number;
  height: number;
}

export const useWindowSize = (): WindowSize => {
  const [width, setWidth] = useState(getWidth());
  const [height, setHeight] = useState(getHeight());

  useEffect(() => {
    let timeoutId = null;
    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setHeight(getHeight());
        setWidth(getWidth());
      }, 166); //Corresponds to 10 frames at 60 Hz. Equals to MaterialUI debounce timeout.
    };

    window.addEventListener("resize", resizeListener);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return { width, height };
};
